/**
 * Joining by invitation. The emailed link carries a one-time token; it is
 * lifted out of the address bar on arrival (so it does not sit in history or
 * get mistaken for a password-reset token) and held for this tab until the
 * person has signed in and set up two-step verification, then redeemed.
 */

import { apiCall } from '../api.ts';

const KEY = 'synanalytics_invite';
const ACCEPT_PATH = '/invitations/accept';

export interface InvitationPreview {
  email: string;
  organisation_name: string;
}

/** Takes the token from an invitation link, if this page load is one, and cleans the URL. */
export function captureInviteFromUrl(): void {
  if (!window.location.pathname.startsWith(ACCEPT_PATH)) return;
  const token = new URLSearchParams(window.location.search).get('token');
  window.history.replaceState({}, '', '/');
  if (!token) return;
  try {
    sessionStorage.setItem(KEY, token);
  } catch {
    // Storage blocked: the invitation can still be opened again from the email.
  }
}

export function pendingInvite(): string | null {
  try {
    return sessionStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function clearPendingInvite(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    // nothing stored
  }
}

export const previewInvitation = (token: string) =>
  apiCall<InvitationPreview>('/invitations/preview', {
    method: 'POST',
    body: JSON.stringify({ token }),
  });

export const acceptInvitation = (token: string) =>
  apiCall<unknown>('/invitations/accept', { method: 'POST', body: JSON.stringify({ token }) });

export const register = (input: {
  email: string;
  password: string;
  first_name: string;
  last_name: string;
  turnstile_token: string;
}) => apiCall<unknown>('/auth/register', { method: 'POST', body: JSON.stringify(input) });
